import * as React from "react"
import {NavLink} from "./navLink";
import {ManualNavigation} from "./manualNavigation";
import {StarterNavigation} from "./starterNavigation";
import {CamstaNavigation} from "./camstaNvigation";


type Props = {
    directory: string
}

export const Navigation: React.FunctionComponent<Props> = ({directory}) => {
    const height = {height: "calc(100vh - 7rem )"}

    return (
        <nav className="hidden sm:block w-1/4 min-w-max relative">
            <div className="sticky overflow-y-auto top-28 mb-8" style={height}>
                <NavLink title="ヘルプサイトトップ" link="/"/>
                {directory === 'starter' ? <StarterNavigation/> : ''}
                {directory === 'manual' ? <ManualNavigation/> : ''}
                {directory === 'camsta' ? <CamstaNavigation/> : ''}
            </div>
        </nav>
    )
}
